import { ClientPropertyListResource, ClientPropertyResource } from "./resource/client-property";
import { OffMarketListingListResource } from "./resource/off-market-listing";
import { ListingPhotoKey, PhotoManagerResource, AddListingPhotoResource, ReorderListingPhotosResource, MakeMainListingPhotoResource } from "./resource/listing-photo";
import { LeadContactReportResource, ContactEventTypeResource } from "./resource/lead-contact-report";
import { SavedSearchActivityReportResource } from "./resource/saved-search-activity";
import { SavedListingReportResource } from "./resource/saved-listing-report";
import { MobileActivityReportResponse } from "./resource/mobile-activity";
import { EmailBrandingResource } from "./resource/email-branding";
import { ActiveListingResource } from "./resource/active-listing";
import { ActiveListingModifyResource, UpdateActiveListingModifyResource } from "./resource/active-listing-modify";
import { UserPartial } from "model/user";
import { FollowUpBossAgentSelection, FollowUpBossAgentSelectionRequest } from "model/follow-up-boss-agent-selection";
import { UserAuth } from "model/user-auth";
import { QuotaResource } from "./resource/quota";
import { Lead, NewLead } from "model/lead";
import { LeadResource } from "./resource/lead";
import { LeadImportResource } from "./resource/lead-import";
import { LeadNote, NewLeadNote } from "model/lead-note";
import { LeadNoteResource } from "./resource/lead-note";
import { LeadTag, NewLeadTag } from "model/lead-tag";
import { LeadTagResource } from "./resource/lead-tag";
import { LeadPhone, NewLeadPhone } from "model/lead-phone";
import { LeadPhoneResource } from "./resource/lead-phone";
import { LeadPhoneType } from "type/lead-phone";
import { NewLeadPipeline } from "model/lead-pipeline";
import { LeadPipelineResource } from "./resource/lead-pipeline";
import { LeadAnniversary, NewLeadAnniversary } from "model/lead-anniversary";
import { LeadAnniversaryResource } from "./resource/lead-anniversary";
import { SavedListing, NewSavedListing } from "model/saved-listing";
import { SavedListingResource } from "./resource/saved-listing";
import { SavedSearch, NewSavedSearch } from "model/saved-search";
import { SavedSearchResource } from "./resource/saved-search";
import { MarketReportSubscriptionResource } from "./resource/market-report-subscription";
import { Campaign, NewCampaign } from "model/campaign";
import { CampaignResource } from "./resource/campaign";
import { CampaignMessage, NewCampaignMessage } from "model/campaign-message";
import { CampaignMessageResource } from "./resource/campaign-message";
import { CampaignCampaignMessage, NewCampaignCampaignMessage } from "model/campaign-campaign-message";
import { CampaignCampaignMessageResource } from "./resource/campaign-campaign-message";
import { CampaignSubscription, NewCampaignSubscription, NewCampaignSubscriptionBatch } from "model/campaign-subscription";
import { CampaignSubscriptionResource, NewCampaignSubscriptionBatchResource } from "./resource/campaign-subscription";
import { TaskResource } from "./resource/task";
import { NewTask, Task } from "model/task";
import moment from "moment";
import { IntegrationPartial } from "model/integration";
import { IntegrationResource } from "./resource/integration";
import { FacebookPagesResource } from "./resource/facebook";
import { CampaignRouteResource } from "./resource/campaign-route";
import { CampaignRoute, NewCampaignRoute } from "model/campaign-route";
import { CampaignStatus } from "type/campaign-status";
import { CampaignCampaignMessageSendEmailResource } from "./resource/campaign-campaign-message-send-email";
import { CampaignCampaignMessageSendEmail } from "model/campaign-campaign-message-send-email";
import { CampaignsSettingsResource } from "./resource/campaigns-settings";
import { CampaignsSettings } from "model/campaigns-settings";
import { Agent, NewAgent } from "model/agent";
import { AgentResource, AgentPublicBioTestimonialResource } from "./resource/agent";
import { AgentBoard, NewAgentBoard } from "model/agent-board";
import { AgentBoardResource } from "./resource/agent-board";
import { BoardOption, ClientBoardListResource, ClientBoardResource } from "./resource/client-board";
import { Office, NewOffice } from "model/office";
import { OfficeResource } from "./resource/office";
import { OfficeBoard, NewOfficeBoard } from "model/office-board";
import { OfficeBoardResource } from "./resource/office-board";
import { CampaignMessageType } from "type/campaign-message";
import { PagePartial } from "model/page";
import { PageResource } from "./resource/page";
import { MarketResource } from "./resource/market";
import { listingIdToParts } from "shared/listing-id";
import { NaturalLanguageSearchSuggestion, NewNaturalLanguageSearchSuggestion } from "model/natural-language-search-suggestion";
import { NaturalLanguageSearchSuggestionResource } from "./resource/natural-language-search-suggestion";
import { AreaSelectorPlaceholder, NewAreaSelectorPlaceholder } from "model/area-selector-placeholder";
import { AreaSelectorPlaceholderResource } from "./resource/area-selector-placeholder";
import { user } from "./mock-data/user";
import { adminMode } from "./mock-data/admin-mode";
import { resellers } from "./mock-data/resellers";
import { clients } from "./mock-data/clients";
import { quota } from "./mock-data/quota";
import { leads } from "./mock-data/leads";
import { savedListings } from "./mock-data/saved-listings";
import { savedSearches } from "./mock-data/saved-searches";
import { savedSearchResultTotals } from "./mock-data/saved-search-result-totals";
import { emailSents } from "./mock-data/email-sents";
import {
	leadSearchProfiles,
	leadConversationHistory,
	leadConversationMessages,
	emptyLeadSearchProfile,
} from "./mock-data/search-agent";
import {
	leadProfileSuggestions,
	currentLeadProfileSuggestionValue,
	applyLeadProfileSuggestion,
} from "./mock-data/lead-profile-suggestions";
import { LeadProfileSuggestionReferenceResource } from "./resource/lead-profile-suggestion";
import { emailClicks } from "./mock-data/email-clicks";
import { leadPhones } from "./mock-data/lead-phones";
import { leadPipelines } from "./mock-data/lead-pipelines";
import { leadAnniversaries } from "./mock-data/lead-anniversaries";
import { leadNotes } from "./mock-data/lead-notes";
import { leadTags } from "./mock-data/lead-tags";
import { leadActivities } from "./mock-data/lead-activities";
import { leadImports } from "./mock-data/lead-imports";
import { leadActivityStats } from "./mock-data/lead-activity-stats";
import { leadLastActivities } from "./mock-data/lead-last-activities";
import { leadLastSearchAgentChats } from "./mock-data/lead-last-search-agent-chats";
import { campaigns } from "./mock-data/campaigns";
import { campaignDisplayCategories } from "./mock-data/campaign-display-categories";
import { CampaignDisplayCategoryResource } from "./resource/campaign-display-category";
import { geographicRoutes } from "./mock-data/geographic-routes";
import { postalCodes} from "./mock-data/postal-codes";
import { roundRobinRoutes } from "./mock-data/round-robin-routes";
import { campaignMessages } from "./mock-data/campaign-messages";
import { campaignCampaignMessages } from "./mock-data/campaign-campign-messages";
import { campaignSubscriptions } from "./mock-data/campaign-subscriptions";
import { campaignEmails } from "./mock-data/campaign-emails";
import { campaignStats } from "./mock-data/campaign-stats";
import { campaignSubscriptionStats } from "./mock-data/campaign-subscription-stats";
import { campaignCampaignMessageStats } from "./mock-data/campaign-campaign-message-stats";
import { campaignRoutes } from "./mock-data/campaign-routes";
import { campaignsSettings } from "./mock-data/campaign-settings";
import { markets } from "./mock-data/markets";
import { naturalLanguageSearchSuggestions } from "./mock-data/natural-language-search-suggestions";
import { areaSelectorPlaceholders } from "./mock-data/area-selector-placeholders";
import { listings } from "./mock-data/listings";
import { marketListings } from "./mock-data/market-listings";
import { marketReports } from "./mock-data/market-reports";
import { MarketListingResource } from "./resource/market-listing";
import { marketReportSubscriptions } from "./mock-data/market-report-subscriptions";
import { tasks } from "./mock-data/tasks";
import { agents } from "./mock-data/agents";
import { boards } from "./mock-data/boards";
import { agentBoards } from "./mock-data/agent-boards";
import { mlsIdReads } from "./mock-data/mls-ids";
import { AgentMlsIdResource, NewAgentMlsIdResource } from "./resource/agent-mls-id";
import { offices } from "./mock-data/offices";
import { officeBoards } from "./mock-data/office-boards";
import { cities } from "./mock-data/cities";
import { neighborhoods } from "./mock-data/neighborhoods";
import { aggregateStats } from "./mock-data/aggregate-stats";
import { integrations } from "./mock-data/intergrations";
import { integrationCalendars } from "./mock-data/intergration-calenders";
import { siteLinks } from "./mock-data/site-links";
import { pages } from "./mock-data/pages";
import { languages } from "./mock-data/languages";
import { MarketReportResource } from "./resource/market-report";
import { NewRoundRobinRoute } from "model/round-robin-route";
import { RoundRobinRouteResource } from "./resource/round-robin-route";
import { GeographicRoute, NewGeographicRoute } from "model/geographic-route";
import { GeographicRouteResource } from "./resource/geographic-route";
import { MarketReportSubscription, NewMarketReportSubscription } from "model/market-report-subscription";
import { Market, NewMarket } from "model/market";
import { MarketListing } from "model/market-listing";
import { MarketReport } from "model/market-report";
import { MarketSettingsResource } from "./resource/market-settings";
import { MobileSettingsResource } from "./resource/mobile-settings";
import { SearchCitiesResource } from "./resource/search-cities";
import { LocationsResource } from "./resource/locations";
import { BillingCardResource, BillingInvoiceResource, BillingResource } from "./resource/billing";
import { billing, billingInvoices, billingScenarios, DECLINED_CARD_TOKEN } from "./mock-data/billing";
import { PropertyTypesResource } from "./resource/property-types";
import { MarketSettings } from "model/market-settings";
import { marketSettings } from "./mock-data/market-settings";
import { NylasTokenRequest, NylasTokenResponse } from "./resource/nylas";
import { pings } from "./mock-data/ping";
import { NewPing } from "model/ping";
import { PingResource } from "./resource/ping";
import { saveBlob } from "shared/save-blob";
import { maskTaxId, normalizeTaxId } from "shared/texting-fields";
import { UserResource } from "./resource/user";
import { TextingTaxIdResource } from "./resource/texting-tax-id";
import { TextMessageCampaignVerificationStatus } from "type/text-message-campaign-verification-status";

const resolve = <T>(data: T, delay = 500) => {
    return new Promise<T>((resolve, reject) => {
        setTimeout(() => resolve(data), delay);
    });
}

const generateId = () => {
    return parseInt(Math.random().toString().split(".")[1]);
}

const generateTimestamp = () => {
    return moment().toISOString();
}

export const createPing = (ping: NewPing) => {
	const resource: PingResource = {
		...ping,
		id: generateId(),
		startTime: generateTimestamp(),
		endTime: generateTimestamp(),
	}
	pings.push(resource);
	return resolve(resource);
}

// MAX-4580: a page can force a white-label reseller account with
// localStorage["mockResellerWhiteLabel"] = "1", the same way billing picks a scenario. The
// default reseller (511) is direct, so the e2e account is a direct customer unless asked.
const resellerForMock = () => {
    const whiteLabel = window.localStorage.getItem("mockResellerWhiteLabel") === "1";
    return whiteLabel ? { ...user.reseller, direct: false } : user.reseller;
};

// The Texting page's states (MAX-3049). A page can pick one with localStorage["mockTextingScenario"]:
// submissionInProgress, mobileVerificationPending, campaignApprovalPending (has a tax ID), active,
// paused or plivo. With none set the client hasn't set up texting, and finishing the wizard moves it to
// Submission In Progress. The full tax ID is held apart, as the server only returns it from the reveal call.
type MockTexting = Pick<UserResource,
    | "textMessageOptIn" | "textMessageCallForwarding" | "tcpaCompliantTimeZone" | "textMessagePhoneNumber"
    | "textMessageBrandingStatus" | "textMessageCampaignVerificationStatus" | "textMessageRegistrationStatus"
    | "textMessageHasTaxId" | "textMessageTaxIdType" | "textMessageTaxIdDefaultType" | "textMessageTaxIdMasked"
    | "textMessageLegalBusinessName" | "textMessageBusinessType" | "textMessageVerificationMobile"
    | "emailSignupPhoneRequired"
> & { dripMMSOptOutDate?: string | Date | null };

const textingNotSetUp: MockTexting = {
    textMessageOptIn: false,
    textMessageCallForwarding: "",
    tcpaCompliantTimeZone: "",
    textMessagePhoneNumber: "",
    textMessageBrandingStatus: null,
    textMessageCampaignVerificationStatus: null,
    textMessageRegistrationStatus: null,
    textMessageHasTaxId: false,
    textMessageTaxIdType: null,
    textMessageTaxIdDefaultType: "EIN",
    textMessageTaxIdMasked: null,
    textMessageLegalBusinessName: null,
    textMessageBusinessType: null,
    textMessageVerificationMobile: null,
    emailSignupPhoneRequired: true,
    dripMMSOptOutDate: null,
};

const textingSetUp: MockTexting = {
    ...textingNotSetUp,
    textMessageOptIn: true,
    textMessageCallForwarding: "(609) 555-0142",
    textMessageVerificationMobile: "(609) 555-0142",
    tcpaCompliantTimeZone: "ET",
    textMessagePhoneNumber: "16096211341",
    textMessageRegistrationStatus: "SUBMISSION_IN_PROGRESS",
};

const textingWithTaxId: MockTexting = {
    ...textingSetUp,
    textMessageHasTaxId: true,
    textMessageTaxIdType: "EIN",
    textMessageTaxIdMasked: "XX-XXX6789",
    textMessageLegalBusinessName: "Acme Realty LLC",
    textMessageBusinessType: "LLC",
};

const textingScenarios: Record<string, MockTexting> = {
    submissionInProgress: textingSetUp,
    mobileVerificationPending: {
        ...textingSetUp,
        textMessageBrandingStatus: "unverified",
        textMessageRegistrationStatus: "MOBILE_VERIFICATION_PENDING",
    },
    campaignApprovalPending: {
        ...textingWithTaxId,
        textMessageBrandingStatus: "pending",
        textMessageRegistrationStatus: "CAMPAIGN_APPROVAL_PENDING",
    },
    active: {
        ...textingWithTaxId,
        textMessageBrandingStatus: "approved",
        textMessageCampaignVerificationStatus: TextMessageCampaignVerificationStatus.VERIFIED,
        textMessageRegistrationStatus: "ACTIVE",
    },
    paused: {
        ...textingWithTaxId,
        textMessageBrandingStatus: "approved",
        textMessageCampaignVerificationStatus: TextMessageCampaignVerificationStatus.VERIFIED,
        textMessageRegistrationStatus: "ACTIVE",
        dripMMSOptOutDate: "2026-10-01T12:00:00.000Z",
    },
    plivo: {
        ...textingSetUp,
        textMessageRegistrationStatus: "ACTIVE",
    },
};

const textingScenario = (): MockTexting => {
    const name = window.localStorage.getItem("mockTextingScenario");
    return { ...((name && textingScenarios[name]) || textingNotSetUp) };
};

let textingMock: MockTexting = textingScenario();
let textingTaxIdMock: string | null = textingMock.textMessageHasTaxId ? "123456789" : null;

const saveTexting = (userPartial: UserPartial): string | undefined => {
    const hasTaxId = userPartial.textMessageHasTaxId ?? textingMock.textMessageHasTaxId;
    const newTaxId = userPartial.textMessageTaxId ? normalizeTaxId(userPartial.textMessageTaxId) : undefined;
    if (hasTaxId) {
        const legalName = userPartial.textMessageLegalBusinessName ?? textingMock.textMessageLegalBusinessName;
        if (!(userPartial.textMessageTaxIdType ?? textingMock.textMessageTaxIdType)
            || !(userPartial.textMessageBusinessType ?? textingMock.textMessageBusinessType)
            || !legalName || !legalName.trim()) {
            return "Tax ID type, business type and legal business name are required.";
        }
        if (newTaxId !== undefined ? newTaxId.length !== 9 : !textingTaxIdMock) {
            return "A 9-digit tax ID is required.";
        }
    }
    const next: MockTexting = { ...textingMock };
    const keys = [
        "textMessageCallForwarding", "tcpaCompliantTimeZone", "textMessageVerificationMobile", "emailSignupPhoneRequired",
        "textMessageTaxIdType", "textMessageLegalBusinessName", "textMessageBusinessType",
    ] as const;
    keys.forEach((key) => {
        const value = userPartial[key];
        if (value !== undefined && value !== null) {
            (next as Record<string, unknown>)[key] = value;
        }
    });
    if ("dripMMSOptOutDate" in userPartial) {
        next.dripMMSOptOutDate = userPartial.dripMMSOptOutDate ?? null;
    }
    if (userPartial.textMessageHasTaxId === false) {
        Object.assign(next, { textMessageHasTaxId: false, textMessageTaxIdType: null, textMessageTaxIdMasked: null, textMessageLegalBusinessName: null, textMessageBusinessType: null });
        textingTaxIdMock = null;
    } else if (userPartial.textMessageHasTaxId) {
        next.textMessageHasTaxId = true;
    }
    if (next.textMessageHasTaxId && newTaxId) {
        textingTaxIdMock = newTaxId;
    }
    if (next.textMessageHasTaxId && textingTaxIdMock) {
        next.textMessageTaxIdMasked = maskTaxId(textingTaxIdMock, next.textMessageTaxIdType || "EIN");
    }
    if (userPartial.textMessageOptIn && !next.textMessageOptIn) {
        next.textMessageOptIn = true;
        next.textMessagePhoneNumber = "16096211341";
        next.textMessageRegistrationStatus = "SUBMISSION_IN_PROGRESS";
    }
    textingMock = next;
    return undefined;
};

export const getTextingTaxId = () => {
    return resolve<TextingTaxIdResource>({ taxId: textingTaxIdMock });
}

export const getUser = () => {
    const agentsWithLeads = agents.filter(a => a.ownsLeads).length;
    const shouldShowTeamFeatures = agentsWithLeads >= 2;
    const updatedUser = {
        ...user,
        reseller: resellerForMock(),
        ...textingMock,
        permissions: {
            ...user.permissions,
            showTeamFeatures: shouldShowTeamFeatures
        }
    };
    return resolve(updatedUser);
}

export const profileSync = () => {
    return resolve({});
}

// Held in module state so saves round-trip like the live API.
let priceRangeOptions = {
    minPrices: [100000, 200000, 300000, 400000, 500000],
    maxPrices: [300000, 400000, 500000, 750000, 1000000],
};

export const getPriceRangeOptions = () => {
    return resolve({ ...priceRangeOptions });
}

export const savePriceRangeOptions = (options: { minPrices: number[]; maxPrices: number[] }) => {
    priceRangeOptions = { minPrices: [...options.minPrices], maxPrices: [...options.maxPrices] };
    return resolve({ ...priceRangeOptions });
}

export const saveUser = (userPartial: UserPartial) => {
    if (userPartial.textMessageAreaCode && (userPartial.textMessageAreaCode === "999" || userPartial.textMessageAreaCode === "000")) {
        throw new Error("Area code failed");
    }
    if (userPartial.textMessageAreaCode) {
        user.textMessageAreaCode = userPartial.textMessageAreaCode;
    }
    const textingError = saveTexting(userPartial);
    if (textingError) {
        return Promise.reject(new Error(textingError));
    }
    if (userPartial.kestrelVersion) {
        user.kestrelVersion = userPartial.kestrelVersion.id;
    }
    if (userPartial.baseUrl) {
        user.baseUrl = userPartial.baseUrl;
    }
    if (userPartial.websitePlatform) {
        user.websitePlatform = typeof userPartial.websitePlatform === "string" ? userPartial.websitePlatform : userPartial.websitePlatform.id;
    }
    if (userPartial.colorScheme) {
        user.colorScheme = userPartial.colorScheme;
    }
    return resolve({ ...user, ...textingMock }, 2000);
}

export const saveUserAuth = (userAuth: UserAuth) => {
    return resolve(userAuth);
}

export const getAdminMode = () => {
    return resolve(adminMode);
}

export const getResellerById = (id: number) => {
    const reseller = resellers.find((reseller) => reseller.id === id);
    if (!reseller) {
        throw new Error();
    }
    return resolve(reseller);
}

export const getClient = (id: number) => {
    const client = clients.find((client) => client.id === id);
    if (!client) {
        throw new Error();
    }
    return resolve(client);
}

export const getQuota = () => {
    return resolve<QuotaResource>(quota);
}

export const getLeads = () => {
    return resolve<LeadResource[]>(leads);
}

export const createLead = (lead: NewLead) => {
	const resource: LeadResource = {
		id: generateId(),
		name: lead.name,
		phone: lead.phone,
		email: lead.email,
		email2: lead.email2,
		address: lead.address,
		city: lead.city,
		state: lead.state,
		zip: lead.zip,
		note: lead.note,
		status: lead.status && lead.status.id,
		agentId:
			lead.agentId !== undefined
				? lead.agentId
				: lead.agent
					? lead.agent.id
					: undefined,
		createdOn: generateTimestamp(),
	}
	leads.push(resource);
	return resolve(resource);
}

/**
 * Sends the fields live.ts sends, and applies them the way ihf-root does: a field is written only
 * when the request carries it, so one left undefined (and dropped from live's JSON) keeps its
 * value, while an explicit null clears it.
 */
export const updateLead = (lead: Lead) => {
	const i = leads.findIndex((value) => value.id === lead.id);
	const body: Partial<LeadResource> = {
		name: lead.name,
		email: lead.email,
		email2: lead.email2,
		phone: lead.phone,
		address: lead.address,
		city: lead.city,
		state: lead.state,
		zip: lead.zip,
		status: lead.status && lead.status.id,
		note: lead.note,
		agentId:
			lead.agentId !== undefined
				? lead.agentId
				: lead.agent
					? lead.agent.id
					: undefined,
		readiness: lead.readiness ? lead.readiness : undefined,
		transactionTimelineStart: lead.transactionTimelineStart
			? lead.transactionTimelineStart
			: undefined,
		transactionTimelineEnd: lead.transactionTimelineEnd
			? lead.transactionTimelineEnd
			: undefined,
		justBrowsing: lead.justBrowsing,
		transactionPrice: lead.transactionPrice ?? undefined,
		workingWithAnotherAgent: lead.workingWithAnotherAgent,
		mortgagePreApproval: lead.mortgagePreApproval,
		referralRequested: lead.referralRequested,
	};
	const sent = Object.fromEntries(Object.entries(body).filter(([, value]) => value !== undefined));
	const resource: LeadResource = {
		...leads[i],
		...sent,
	};
	leads[i] = resource;
	return resolve(resource);
}

export const getSavedListings = (leadId: number) => {
    return resolve(savedListings.filter((savedListing) => savedListing.leadId === leadId));
}

export const createSavedListing = (savedListing: NewSavedListing) => {
	const resource: SavedListingResource = {
		id: generateId(),
		leadId: savedListing.lead.id,
		createdOn: generateTimestamp(),
		rating: savedListing.rating,
		comments: savedListing.comments,
		deleted: savedListing.deleted ? savedListing.deleted : false,
		listing: {
			//@ts-ignore
			id: savedListing.listing ? savedListing.listing.id : undefined,
			listingNumber: "1001686857_2",
			address: "1213 Alvorado Ave\\n Davis, CA 94109",
			bedrooms: 3,
			fullBathrooms: 2,
			price: 700000,
			photoUrl: "https://img.zumpercdn.com/191663977/1280x960?auto=format&w=392&h=360",
			detailUrl: "https://example.com",
		},
	}
	return resolve<SavedListingResource>(resource);
}

export const updateSavedListing = (savedListing: SavedListing) => {
	const i = savedListings.findIndex((value) => value.id === savedListing.id);
	const resource = {
		...savedListings[i],
		comments: savedListing.comments,
		rating: savedListing.rating,
		deleted: savedListing.deleted ? savedListing.deleted : false,
	};
	savedListings[i] = resource;
	return resolve(resource);
}

export const getSavedSearches = () => {
    return resolve(savedSearches);
}

export const createSavedSearch = (savedSearch: NewSavedSearch) => {
	const resource: SavedSearchResource = {
		id: generateId(),
		leadId: savedSearch.leadId,
		comments: savedSearch.comments,
		recieveEmails: savedSearch.recieveEmails,
		inactive: savedSearch.inactive,
		criteria: savedSearch.criteria,
		createdOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		modifiedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	savedSearches.push(resource);
	return resolve(resource);
}

export const updateSavedSearch = (savedSearch: SavedSearch) => {
	const i = savedSearches.findIndex((value) => value.id === savedSearch.id);
	const resource = {
		...savedSearches[i],
		comments: savedSearch.comments,
		recieveEmails: savedSearch.recieveEmails,
		inactive: savedSearch.inactive,
		criteria: savedSearch.criteria,
	};
	savedSearches[i] = resource;
	return resolve(resource);
} 

export const getSavedSearchResultTotal = (savedSearchId: number) => {
    return resolve(savedSearchResultTotals.find(savedSearchResultTotal => savedSearchResultTotal.id === savedSearchId));
}

export const getLeadSearchProfile = (leadId: number) => {
    const profile = leadSearchProfiles.find((leadSearchProfile) => leadSearchProfile.leadId === leadId);
    return resolve(profile || emptyLeadSearchProfile(leadId));
}

export const deleteLeadSearchProfileHistory = (leadId: number) => {
    const index = leadSearchProfiles.findIndex((leadSearchProfile) => leadSearchProfile.leadId === leadId);
    if (index >= 0) {
        leadSearchProfiles.splice(index, 1);
    }
    return resolve(undefined);
}

export const getLeadConversationHistory = (leadId: number) => {
    return resolve(leadConversationHistory[leadId] || []);
}

export const getLeadConversationHistoryDay = (leadId: number, date: string) => {
    return resolve((leadConversationMessages[leadId] || {})[date] || []);
}

/**
 * Each suggestion's `current` side is read off the mock lead at request time, the way the
 * server reads it, so it stays right after an accept writes to that lead.
 */
export const getLeadProfileSuggestions = (leadId: number) => {
    const lead = leads.find((value) => value.id === leadId);
    return resolve(leadProfileSuggestions
        .filter((suggestion) => suggestion.leadId === leadId)
        .map(({ leadId, ...suggestion }) => ({
            ...suggestion,
            current: lead ? currentLeadProfileSuggestionValue(lead, suggestion.field) : {},
        })));
}

const isNamed = (
    suggestion: { leadId: number, field: string, suggestedOn: string },
    leadId: number,
    references: LeadProfileSuggestionReferenceResource[]
) => {
    return suggestion.leadId === leadId && references.some((reference) =>
        reference.field === suggestion.field && reference.suggestedOn === suggestion.suggestedOn);
}

export const acceptLeadProfileSuggestions = (leadId: number, suggestions: LeadProfileSuggestionReferenceResource[]) => {
    const i = leads.findIndex((value) => value.id === leadId);
    let resource = { ...leads[i] };
    leadProfileSuggestions
        .filter((suggestion) => isNamed(suggestion, leadId, suggestions))
        .forEach((suggestion) => {
            resource = applyLeadProfileSuggestion(resource, suggestion);
        });
    leads[i] = resource;
    removeLeadProfileSuggestions(leadId, suggestions);
    return resolve(resource);
}

export const dismissLeadProfileSuggestions = (leadId: number, suggestions: LeadProfileSuggestionReferenceResource[]) => {
    removeLeadProfileSuggestions(leadId, suggestions);
    return resolve(undefined);
}

const removeLeadProfileSuggestions = (leadId: number, references: LeadProfileSuggestionReferenceResource[]) => {
    for (let i = leadProfileSuggestions.length - 1; i >= 0; i--) {
        const suggestion = leadProfileSuggestions[i];
        if (isNamed(suggestion, leadId, references)) {
            leadProfileSuggestions.splice(i, 1);
        }
    }
}

export const getEmailSents = (leadId: number) => {
    return resolve(emailSents.filter((emailSent) => emailSent.leadId === leadId));
}

export const getEmailClicks = (leadId: number) => {
    return resolve(emailClicks.filter((emailClick) => emailClick.leadId === leadId));
}

export const getLeadPhones = () => {
    return resolve(leadPhones);
}

export const createLeadPhone = (leadPhone: NewLeadPhone) => {
	const resource: LeadPhoneResource = {
		id: generateId(),
		leadId: leadPhone.leadId,
		typeId: leadPhone.type?.id ?? LeadPhoneType.MOBILE.id,
		value: leadPhone.value,
		deleted: leadPhone.deleted,
		createdOn: moment().utcOffset(0, true).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		updatedOn: moment().utcOffset(0, true).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	}
	leadPhones.push(resource);
	return resolve(resource);
}

export const updateLeadPhone = (leadPhone: LeadPhone) => {
	const i = leadPhones.findIndex((value) => value.id === leadPhone.id);
	const resource = {
		...leadPhones[i],
		leadId: leadPhone.leadId,
		typeId: leadPhone.type?.id ?? LeadPhoneType.MOBILE.id,
		value: leadPhone.value,
		deleted: leadPhone.deleted,
		updatedOn: moment().utcOffset(0, true).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	}
	leadPhones[i] = resource;
	return resolve(resource);
}

export const getLeadPipelines = () => {
    return resolve(leadPipelines);
}

export const createLeadPipeline = (leadPipeline: NewLeadPipeline) => {
    let resource: LeadPipelineResource;
        resource = {
            id: generateId(),
            leadId: leadPipeline.leadId,
            typeId: leadPipeline.type && leadPipeline.type.id,
            createdOn: generateTimestamp(),
        }
        leadPipelines.push(resource);
    return resolve<LeadPipelineResource>(resource);
}

export const getLeadAnniversaries = () => {
    return resolve(leadAnniversaries);
}

export const createLeadAnniversary = (leadAnniversary: NewLeadAnniversary) => {
	const resource: LeadAnniversaryResource = {
		id: generateId(),
		leadId: leadAnniversary.lead && leadAnniversary.lead.id,
		typeId: leadAnniversary.type && leadAnniversary.type.id,
		startDate: leadAnniversary.startDate.toString(),
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		deleted: false,
		createdOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	leadAnniversaries.push(resource);
	return resolve<LeadAnniversaryResource>(resource);
};

export const updateLeadAnniversary = (leadAnniversary: LeadAnniversary) => {
	const index = leadAnniversaries.findIndex((value) => value.id === leadAnniversary.id);
	const resource = {
		...leadAnniversaries[index],
		leadId: leadAnniversary.lead && leadAnniversary.lead.id,
		typeId: leadAnniversary.type && leadAnniversary.type.id,
		startDate: leadAnniversary.startDate.toString(),
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		deleted: leadAnniversary.deleted,
	};
	leadAnniversaries[index] = resource;
	return resolve<LeadAnniversaryResource>(resource);
};

export const getLeadNotes = () => {
    return resolve(leadNotes);
}

export const createLeadNote = (leadNote: NewLeadNote) => {
	const text = (leadNote.text) ? leadNote.text : "";
	const resource: LeadNoteResource = {
		id: generateId(),
		leadId: generateId(),
		typeId: leadNote.type && leadNote.type.id,
		text,
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		deleted: false,
		createdOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	leadNotes.push(resource);
	return resolve<LeadNoteResource>(resource);
};

export const updateLeadNote = (leadNote: LeadNote) => {
	const i = leadNotes.findIndex((value) => value.id === leadNote.id);
	const text = (leadNote.text) ? leadNote.text : "";
    let resource: LeadNoteResource = {
		...leadNotes[i],
		leadId: leadNote.leadId,
		typeId: leadNote.type && leadNote.type.id,
		text,
		deleted: leadNote.deleted,
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
    leadNotes[i] = resource;
	return resolve<LeadNoteResource>(resource);
};

export const getLeadTags = () => {
    return resolve(leadTags);
}

export const createLeadTag = (leadTag: NewLeadTag) => {
    const resource: LeadTagResource = {
        id: generateId(),
        leadId: leadTag.leadId,
        text: leadTag.text,
		createdOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
    };
    leadTags.push(resource);
    return resolve<LeadTagResource>(resource);
}

export const deleteLeadTag = (leadTag: LeadTag) => {
    const i = leadTags.findIndex(value => value.id === leadTag.id);
    const resource = leadTags[i];
    leadTags.splice(i, 1);
    return resolve(resource);
}

export const getLeadActivities = (leadId?: number) => {
    if (leadId) {
        return resolve(leadActivities.filter((leadActivity) => leadActivity.leadId === leadId));
    } else {
        return resolve(leadActivities);
    }
}

export const saveLeadImport = (leadImportResources: LeadImportResource[]) => {
    leadImportResources.forEach((leadImportResource) => {
        let leadResource: LeadResource; 
        const i = leads.findIndex((value) => value.email === leadImportResource.email);
        if (leads[i] && leads[i].status === "deleted") {
            leadResource = {
                ...leads[i],
                name: leadImportResource.name,
                phone: leadImportResource.phone,
                email: leadImportResource.email,
                address: leadImportResource.address,
                city: leadImportResource.city,
                state: leadImportResource.state,
                zip: leadImportResource.zip,
                status: "active",
            }
            if (leadImportResource.note === "error") {
                leadImportResource.message = "import_failed";
            }
            if (leadImportResource.note === "action") {
                leadImportResource.message = "action_failed";
            }
            if (!leadImportResource.message) {
                leads[i] = leadResource;
            }
        } else if (leads[i]) {
            leadImportResource.message = "duplicate_lead";
        } else {
            leadResource = {
                id: generateId(),
                name: leadImportResource.name,
                phone: leadImportResource.phone,
                email: leadImportResource.email,
                address: leadImportResource.address,
                city: leadImportResource.city,
                state: leadImportResource.state,
                zip: leadImportResource.zip,
                status: "active",
            };
            if (leadImportResource.note === "error") {
                leadImportResource.message = "import_failed";
            }
            if (leadImportResource.note === "action") {
                leadImportResource.message = "action_failed";
            }
            if (!leadImportResource.message) {
                leads.push(leadResource);
            }
        }
    });
    leadImportResources.forEach((leadImportResource) => leadImports.push(leadImportResource));
    return resolve<LeadImportResource[]>(leadImportResources);
}

export const getLeadActivityStats = () => {
    return resolve(leadActivityStats);
}

export const getLeadLastActivities = () => {
    return resolve(leadLastActivities);
}

export const getLeadLastSearchAgentChats = () => {
    return resolve(leadLastSearchAgentChats);
}

export const getCampaigns = () => {
    return resolve(campaigns);
}

export const getCampaignDisplayCategories = () => {
    return resolve(campaignDisplayCategories);
}

export const createCampaignDisplayCategory = (name: string) => {
    const resource: CampaignDisplayCategoryResource = { id: generateId(), name };
    campaignDisplayCategories.push(resource);
    return resolve<CampaignDisplayCategoryResource>(resource);
}

export const updateCampaignDisplayCategory = (id: number, name: string) => {
    const resource: CampaignDisplayCategoryResource = { id, name };
    const i = campaignDisplayCategories.findIndex((c) => c.id === id);
    if (i >= 0) {
        campaignDisplayCategories[i] = resource;
    }
    return resolve<CampaignDisplayCategoryResource>(resource);
}

export const deleteCampaignDisplayCategory = (id: number, moveToId?: number | null) => {
    // Mirror the server's Move-&-Delete: reassign this category's campaigns, then drop the row.
    // moveToId null/undefined ⇒ Uncategorized (null FK).
    campaigns.forEach((campaign) => {
        if (campaign.campaignDisplayCategoryId === id) {
            campaign.campaignDisplayCategoryId = moveToId ?? null;
        }
    });
    const i = campaignDisplayCategories.findIndex((c) => c.id === id);
    if (i >= 0) {
        campaignDisplayCategories.splice(i, 1);
    }
    return resolve<void>(undefined);
}

export const createCampaign = (campaign: NewCampaign) => {
	const resource: CampaignResource = {
		id: generateId(),
		name: campaign.name,
		emailMarketingTypeId: campaign.emailMarketingType.id,
		dateCreated: generateTimestamp(),
		// MAX-3879: respect the "Set as active" toggle instead of always creating active.
		status: campaign.status ? campaign.status.id : CampaignStatus.INACTIVE.id,
		campaignDisplayCategoryId: campaign.campaignDisplayCategoryId,
		inactiveYn: campaign.inactiveYn,
	};
	campaigns.push(resource);
	return resolve<CampaignResource>(resource);
};

export const updateCampaign = (campaign: Campaign) => {
	const resource: CampaignResource = {
		id: campaign.id,
		name: campaign.name,
		emailMarketingTypeId: campaign.emailMarketingType.id,
		dateCreated: campaign.dateCreated.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		status: campaign.status?.id,
		campaignDisplayCategoryId: campaign.campaignDisplayCategoryId,
		inactiveYn: campaign.inactiveYn,
	};
	const i = campaigns.findIndex((value) => value.id === campaign.id);
	campaigns[i] = resource;
	return resolve<CampaignResource>(resource);
};

export const getGeographicRoutes = () => {
	return resolve(geographicRoutes);
}

export const createGeographicRoute = (geographicRoute: NewGeographicRoute) => {
	const resource: GeographicRouteResource = {
		id: generateId(),
		agentId: geographicRoute.agent.id,
		postalCode: geographicRoute.postalCode,
		createdOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	}
	geographicRoutes.push(resource);
	return resolve<GeographicRouteResource>(resource);
};


export const deleteGeographicRoute = (geographicRoute: GeographicRoute) => {
		const i = geographicRoutes.findIndex(value => value.id === geographicRoute.id);
		const resource = geographicRoutes[i];
		geographicRoutes.splice(i, 1);
		return resolve(resource);
}

export const getRoundRobinRoutes = () => {
	return resolve(roundRobinRoutes);
}

export const updateRoundRobinRoutes = (_roundRobinRoutes: NewRoundRobinRoute[]) => {
	roundRobinRoutes.length = 0;
	for (let i = 0; i < _roundRobinRoutes.length; i++) {
		const resource: RoundRobinRouteResource = {
			id: generateId(),
			agentId: _roundRobinRoutes[i].agent.id,
			createdOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		}
		roundRobinRoutes.push(resource);
	}
	return resolve<RoundRobinRouteResource[]>(roundRobinRoutes);
}

export const getPostalCodes = () => {
	return resolve(postalCodes);
}


export const getCampaignMessages = () => {
    return resolve(campaignMessages);
}

export const resendTextingOtpVerification = () => {
	return resolve(true);
}

export const createCampaignMessage = (campaignMessage: NewCampaignMessage) => {
	const resource: CampaignMessageResource = {
		id: generateId(),
		name: campaignMessage.name,
		subject: campaignMessage.subject,
		htmlContent: campaignMessage.htmlContent,
		jsonContent: campaignMessage.jsonContent,
		messageType: campaignMessage.messageType ? campaignMessage.messageType.id : CampaignMessageType.TEXT.id,
		timeToSendNumber: campaignMessage.timeToSendNumber,
		timeToSendUnit: campaignMessage.timeToSendUnit && campaignMessage.timeToSendUnit.id,
		status: campaignMessage.status && campaignMessage.status.id,
		ownedByReseller: campaignMessage.ownedByReseller,
		isInactiveYn: campaignMessage.isInactiveYn,
		attachments: campaignMessage.attachments,
		dateCreated: generateTimestamp(),
	};
	campaignMessages.push(resource);
	return resolve<CampaignMessageResource>(resource);
};

export const updateCampaignMessage = (campaignMessage: CampaignMessage) => {
	const resource: CampaignMessageResource = {
		id: campaignMessage.id,
		name: campaignMessage.name,
		subject: campaignMessage.subject,
		htmlContent: campaignMessage.htmlContent,
		jsonContent: campaignMessage.jsonContent,
		messageType: campaignMessage.messageType ? campaignMessage.messageType.id : CampaignMessageType.TEXT.id,
		timeToSendNumber: campaignMessage.timeToSendNumber,
		timeToSendUnit: campaignMessage.timeToSendUnit && campaignMessage.timeToSendUnit.id,
		status: campaignMessage.status && campaignMessage.status.id,
		ownedByReseller: campaignMessage.ownedByReseller,
		isInactiveYn: campaignMessage.isInactiveYn,
		attachments: campaignMessage.attachments,
		dateCreated: campaignMessage.dateCreated.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	const i = campaignMessages.findIndex((value) => value.id === campaignMessage.id);
	campaignMessages[i] = resource;
	return resolve<CampaignMessageResource>(resource);
};

export const deleteCampaignMessage = (campaignMessage: CampaignMessage) => {
    const i = campaignMessages.findIndex(value => value.id === campaignMessage.id);
    const resource = campaignMessages[i];
    campaignMessages.splice(i, 1);
    return resolve(resource);
}

export const getCampaignCampaignMessages = () => {
    return resolve(campaignCampaignMessages);
}

export const createCampaignCampaignMessage = (campaignCampaignMessage: NewCampaignCampaignMessage) => {
	const resource: CampaignCampaignMessageResource = {
		id: generateId(),
		campaignId: campaignCampaignMessage.campaignId,
		campaignMessageId: campaignCampaignMessage.campaignMessageId,
		messageOrder: campaignCampaignMessage.messageOrder,
		dateCreated: generateTimestamp(),
	};
	campaignCampaignMessages.push(resource);
	return resolve<CampaignCampaignMessageResource>(resource);
};

export const updateCampaignCampaignMessage = (campaignCampaignMessage: CampaignCampaignMessage) => {
	const resource: CampaignCampaignMessageResource = {
		id: campaignCampaignMessage.id,
		campaignId: campaignCampaignMessage.campaignId,
		campaignMessageId: campaignCampaignMessage.campaignMessageId,
		messageOrder: campaignCampaignMessage.messageOrder,
		dateCreated: campaignCampaignMessage.dateCreated.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	const i = campaignCampaignMessages.findIndex((value) => value.id === campaignCampaignMessage.id);
	campaignCampaignMessages[i] = resource;
	return resolve<CampaignCampaignMessageResource>(resource);
};

export const updateCampaignCampaignMessages = (updatedCampaignCampaignMessages: CampaignCampaignMessage[]) => {
    updatedCampaignCampaignMessages.forEach((campaignCampaignMessage) => {
        let resource: CampaignCampaignMessageResource;
        resource = {
            id: campaignCampaignMessage.id,
            campaignId: campaignCampaignMessage.campaignId,
            campaignMessageId: campaignCampaignMessage.campaignMessageId,
            messageOrder: campaignCampaignMessage.messageOrder,
			dateCreated: campaignCampaignMessage.dateCreated.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        };
        const i = campaignCampaignMessages.findIndex((value) => value.id === campaignCampaignMessage.id);
        campaignCampaignMessages[i] = resource;
    });
    return resolve(campaignCampaignMessages);
}

export const sendCampaignCampagaignMessageEmailTest = (campaignCampaignMessageSendEmail: CampaignCampaignMessageSendEmail) => {
    const resource: CampaignCampaignMessageSendEmailResource = {
        campaignCampaignMessageId: campaignCampaignMessageSendEmail.campaignCampaignMessage.id,
        leadId: campaignCampaignMessageSendEmail.lead.id,
    }
    return resolve<CampaignCampaignMessageSendEmailResource>(resource);
}

export const getCampaignSubscriptions = () => {
    return resolve(campaignSubscriptions);
}

export const createCampaignSubscription = (subscription: NewCampaignSubscription) => {
	const resource: CampaignSubscriptionResource = {
		id: generateId(),
		campaignId: subscription.campaign && subscription.campaign.id,
		leadId: subscription.lead && subscription.lead.id,
		status: subscription.status && subscription.status.id,
		createdOn: generateTimestamp(),
	};
	campaignSubscriptions.push(resource);
	return resolve<CampaignSubscriptionResource>(resource);
};

export const createCampaignSubscriptionsBatch = (batch: NewCampaignSubscriptionBatch) => {
	batch.leadIds.forEach((leadId) => {
		const resource: CampaignSubscriptionResource = {
			id: generateId(),
			campaignId: batch.campaign && batch.campaign.id,
			leadId,
			status: batch.status && batch.status.id,
			createdOn: generateTimestamp(),
		};
		campaignSubscriptions.push(resource);
	});
	const result: NewCampaignSubscriptionBatchResource = {
		campaignId: batch.campaign && batch.campaign.id,
		leadIds: batch.leadIds,
		status: batch.status && batch.status.id,
	};
	return resolve<NewCampaignSubscriptionBatchResource>(result);
};

export const updateCampaignSubscription = (subscription: CampaignSubscription) => {
	const resource: CampaignSubscriptionResource = {
		id: subscription.id,
		campaignId: subscription.campaign && subscription.campaign.id,
		leadId: subscription.lead && subscription.lead.id,
		status: subscription.status && subscription.status.id,
		createdOn: subscription.createdOn.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	const i = campaignSubscriptions.findIndex((value) => value.id === subscription.id);
	campaignSubscriptions[i] = resource;
	return resolve<CampaignSubscriptionResource>(resource);
};

export const getCampaignEmails = (leadId?: number, campaignId?: number, blast?: boolean) => {
    if (leadId || campaignId) {
        return resolve(campaignEmails.filter((campaignEmail) => campaignEmail.leadId === leadId || campaignEmail.campaignId === campaignId));
    }
    // if request doesn't include leadId or campaignId
    // then assume request wants all campaginEmails
    // aka blast is true
    return resolve(campaignEmails);
}

export const getCampaignStats = () => {
    return resolve(campaignStats);
}

export const getCampaignSubscriptionStats = () => {
    return resolve(campaignSubscriptionStats);
}

export const getCampaignCampaignMessageStats = () => {
    return resolve(campaignCampaignMessageStats);
}

export const getCampaignRoutes = () => {
    return resolve(campaignRoutes);
}

export const createCampaignRoute = (campaignRoute: NewCampaignRoute) => {
	// MAX-3857: always resolved by the caller.
	const resource: CampaignRouteResource = {
		id: generateId(),
		campaignId: campaignRoute.campaign!.id,
		triggers: campaignRoute.triggers,
		enrollmentMode: campaignRoute.enrollmentMode,
		inactive: campaignRoute.inactive,
		// MAX-3873: a brand-new route has driven no enrollments yet.
		enrollmentCount: 0,
	}
	campaignRoutes.push(resource);
	return resolve<CampaignRouteResource>(resource);
};

export const updateCampaignRoute = (campaignRoute: CampaignRoute) => {
	// MAX-3857: unlike createCampaignRoute, this is called from more than one place
	// (including toggling a route's Active switch), so the campaign isn't always
	// guaranteed by a single caller -- fail loudly instead of asserting.
	if (!campaignRoute.campaign) {
		throw new Error("updateCampaignRoute requires a campaign");
	}
	const i = campaignRoutes.findIndex((value) => value.id === campaignRoute.id);
	const resource: CampaignRouteResource = {
		id: campaignRoute.id,
		campaignId: campaignRoute.campaign.id,
		triggers: campaignRoute.triggers,
		enrollmentMode: campaignRoute.enrollmentMode,
		inactive: campaignRoute.inactive,
		// MAX-3873: enrollmentCount is server-computed and read-only — the client never sends it.
		// Preserve the existing count so it stays visible after a mock edit/toggle.
		enrollmentCount: campaignRoutes[i]?.enrollmentCount ?? 0,
	}
	campaignRoutes[i] = resource;
	return resolve<CampaignRouteResource>(resource);
};

export const deleteCampaignRoute = (campaignRoute: CampaignRoute) => {
    const i = campaignRoutes.findIndex(value => value.id === campaignRoute.id);
    const resource = campaignRoutes[i];
    campaignRoutes.splice(i, 1);
    return resolve(resource);
}

export const getCampaignsSettings = () => {
    return resolve(campaignsSettings);
}

export const updateCampaignsSettings = (updatedCampaignsSettings: CampaignsSettings) => {
    const resource: CampaignsSettingsResource = {
        dynamicContentAddress: updatedCampaignsSettings.dynamicContentAddress,
        leadId: updatedCampaignsSettings.lead && updatedCampaignsSettings.lead.id
    }
    campaignsSettings.dynamicContentAddress = resource.dynamicContentAddress;
    if (resource.leadId) {
        campaignsSettings.leadId = resource.leadId;
    } else if (campaignsSettings.leadId) {
        campaignsSettings.leadId = undefined;
    }
    return resolve<CampaignsSettingsResource>(resource)
}

export const getMarkets = () => {
    return resolve(markets);
}

export const createMarket = (market: NewMarket) => {
    const marketResource: MarketResource = {
        ...market,
		inactive: market.inactive ? market.inactive : false,
        id: generateId(),
    }
    markets.push(marketResource);
    return resolve<MarketResource>(marketResource)
}

export const updateMarket = (market: Market) => {
	const resource: MarketResource = {
		id: market.id,
		name: market.name,
		inactive: market.inactive ? market.inactive : false,
	}
    const i = markets.findIndex((value) => value.id === market.id);
    markets[i] = resource;
    if (market.criteria) {
        const idsCriterion = market.criteria.find((criterion) => criterion.name === "ids");
        if (idsCriterion) {
            const values = idsCriterion.value as string[];
            values.forEach((value) => {
                const listingIndex = listings.findIndex((listing) => listing.id === value)
                const included = marketListings.some((marketListing) => marketListing.value === value);
                const parts = listingIdToParts(value);
                if (!included && parts) {
                    marketListings.push({
                        id: generateId(),
                        marketId: market.id,
                        value: parts.listingNumber ? parts.listingNumber : value,
						boardId: parts.boardId,
                        listing: listingIndex >= 0 ? listings[listingIndex] : undefined,
                    })
                }
            });
        }
    }
    return resolve<MarketResource>(resource)
}

export const getMarketSettings = () => {
    return resolve(marketSettings);
}

export const updateMarketSettings = (updatedMarketSettings: MarketSettings) => {
    const resource: MarketSettingsResource = {
        listingCarouselColumns: updatedMarketSettings.listingCarouselColumns,
		communitiesLayout: updatedMarketSettings.communitiesLayout
    }
    return resolve<MarketSettingsResource>(resource)
}

export const getMobileSettings = () => {
    return resolve<MobileSettingsResource>({});
}

export const updateMobileSettings = (body: MobileSettingsResource) => {
    return resolve<MobileSettingsResource>(body);
}

let searchCitiesMock: SearchCitiesResource = {
    cityIds: [],
    customCityListYn: false,
    restrictToCustomList: false,
    cityListFormat: 2,
    isResponsive: true,
};

export const getSearchCities = () => {
    return resolve<SearchCitiesResource>(searchCitiesMock);
}

export const updateSearchCities = (body: SearchCitiesResource) => {
    searchCitiesMock = { ...body, isResponsive: searchCitiesMock.isResponsive };
    return resolve<SearchCitiesResource>(searchCitiesMock);
}

let locationsMock: LocationsResource = {
    boards: [
        {
            boardId: 1,
            boardName: "Northwest Multiple Listing Service (NWMLS)",
            locationTypes: [
                {
                    metaField: "mlsarea",
                    defaultLabel: "MLS Area",
                    selected: false,
                    displayName: "MLS Area",
                    includedLocations: [
                        "Bellevue", "Bothell/Kenmore", "Eastside", "Kirkland", "Mercer Island",
                        "North Seattle", "Redmond", "Shoreline/Kenmore", "South Seattle", "West Seattle",
                    ],
                },
                {
                    metaField: "subdivision",
                    defaultLabel: "Subdivision",
                    selected: false,
                    displayName: "Subdivision",
                    includedLocations: ["Ballard", "Capitol Hill", "Fremont", "Green Lake", "Queen Anne"],
                },
            ],
        },
    ],
    cityIds: [],
    customCityListYn: false,
    restrictToCustomList: false,
    cityListFormat: 1,
    isResponsive: true,
};

export const getLocations = () => {
    return resolve<LocationsResource>(locationsMock);
}

export const updateLocations = (body: LocationsResource) => {
    locationsMock = { ...body, isResponsive: locationsMock.isResponsive };
    return resolve<LocationsResource>(locationsMock);
}

let propertyTypesMock: PropertyTypesResource = {
    showPriceFields: false,
    propertyTypes: [
        { propertyTypeId: 1, title: "House / Condo", code: "SFRCND", enabled: true, customName: null, sequence: 1, minPrice: null, maxPrice: null, boardSupported: true },
        { propertyTypeId: 2, title: "House", code: "SFR", enabled: true, customName: null, sequence: 2, minPrice: null, maxPrice: null, boardSupported: true },
        { propertyTypeId: 3, title: "Condo", code: "CND", enabled: true, customName: null, sequence: 3, minPrice: null, maxPrice: null, boardSupported: true },
        { propertyTypeId: 4, title: "Lots / Land", code: "LND", enabled: true, customName: null, sequence: 4, minPrice: null, maxPrice: null, boardSupported: true },
        { propertyTypeId: 5, title: "Multi-Unit Residential", code: "RIP", enabled: true, customName: null, sequence: 5, minPrice: null, maxPrice: null, boardSupported: true },
        { propertyTypeId: 6, title: "Mobile Home", code: "MOB", enabled: true, customName: null, sequence: 6, minPrice: null, maxPrice: null, boardSupported: true },
        { propertyTypeId: 7, title: "Rental", code: "RNT", enabled: false, customName: null, sequence: 7, minPrice: null, maxPrice: null, boardSupported: false },
        { propertyTypeId: 8, title: "Commercial", code: "COM", enabled: true, customName: null, sequence: 8, minPrice: null, maxPrice: null, boardSupported: true },
        { propertyTypeId: 9, title: "Farm", code: "FRM", enabled: false, customName: null, sequence: 9, minPrice: null, maxPrice: null, boardSupported: false },
    ],
};

export const getPropertyTypes = () => {
    return resolve<PropertyTypesResource>(propertyTypesMock);
}

export const updatePropertyTypes = (body: PropertyTypesResource) => {
    propertyTypesMock = { ...body, showPriceFields: propertyTypesMock.showPriceFields };
    return resolve<PropertyTypesResource>(propertyTypesMock);
}

export const restorePropertyTypes = () => {
    propertyTypesMock = {
        ...propertyTypesMock,
        propertyTypes: propertyTypesMock.propertyTypes.map((pt) => ({
            ...pt, enabled: true, customName: null, minPrice: null, maxPrice: null,
        })),
    };
    return resolve<PropertyTypesResource>(propertyTypesMock);
}

export const getMarketReports = () => {
    return resolve(marketReports);
}

export const updateMarketReport = (marketReport: MarketReport, marketId: number) => {
	const resource: MarketReportResource = {
		id: marketReport.id,
		typeId: marketReport.type.id,
		marketId: marketId,
		customUrl: marketReport.customUrl,
		inactive: marketReport.inactive, 
	};
    const i = marketReports.findIndex((value) => value.id === marketReport.id);
    marketReports[i] = resource;
    return resolve<MarketReportResource>(resource)
}

export const getMarketListings = () => {
    /**
     * simulate returning associated Listing object
     */
    const resources = marketListings.map((marketListing) => {
        const listingIndex = listings.findIndex((listing) => listing.id === marketListing.value)
        return {
            ...marketListing,
            listing: listings[listingIndex],
        }
    })
    return resolve(resources);
}

export const updateMarketListing = (marketListing: MarketListing) => {
	const resource: MarketListingResource = {
		id: marketListing.id,
		marketId: marketListing.marketId,
		boardId: marketListing.boardId,
		value: marketListing.value
	}
    const i = marketListings.findIndex((value) => value.id === resource.id);
    marketListings[i] = resource;
        const included = marketListings.some((marketListing) => marketListing.id === resource.id);
        if (!included) {
            marketListings.push({
                id: resource.id,
                marketId: resource.marketId,
                value: resource.value,
				boardId: resource.boardId,
                listing: resource.listing,
            })
        }
    return resolve<MarketListingResource>(resource)
}

export const updateMarketListings = (marketListings: MarketListing[]) => {
	const updatedResources = marketListings.map((resource) => {
	    const i = marketListings.findIndex((value) => value.id === resource.id);
	    marketListings[i] = resource;
	    const listingIndex = listings.findIndex((listing) => listing.id === resource.value)
	    const marketListingResource: MarketListingResource = {
	        id: resource.id,
	        marketId: resource.marketId,
	        value: resource.value,
			boardId: resource.boardId,
	        listing: listings[listingIndex],
	    }
	    return marketListingResource
	});
    return resolve<MarketListingResource[]>(updatedResources)
}

export const deleteMarketListing = (marketListing: MarketListing) => {
    const i = marketListings.findIndex(value => value.id === marketListing.id);
    const resource = marketListings[i];
    marketListings.splice(i, 1);
    return resolve(resource);
}

export const getMarketReportSubscriptions = () => {
    return resolve(marketReportSubscriptions);
}

//MarketSubscriptions

export const createMarketReportSubscription = (resource: NewMarketReportSubscription) => {
    const newResource: MarketReportSubscriptionResource = {
        id: generateId(),
        marketReportId: resource.report.id,
        leadId: resource.lead.id,
        inactive: resource.inactive,
    }
    marketReportSubscriptions.push(newResource);
    return resolve<MarketReportSubscriptionResource>(newResource);
}

export const updateMarketReportSubscription = (resource: MarketReportSubscription) => {
    const updateResource: MarketReportSubscriptionResource = {
        id: resource.id,
        marketReportId: resource.report.id,
        leadId: resource.lead.id,
        inactive: resource.inactive,
    };
    const i = marketReportSubscriptions.findIndex((value) => value.id === updateResource.id);
    marketReportSubscriptions[i] = updateResource;
    return resolve<MarketReportSubscriptionResource>(updateResource);
}

export const updateMarketSubscriptions = (marketId: number, subscriptions: (NewMarketReportSubscription | MarketReportSubscription)[]) => {
    subscriptions.forEach((subscription) => {
        if ("id" in subscription) {
			const resource: MarketReportSubscriptionResource = {
				id: subscription.id,
				marketReportId: subscription.report.id,
				leadId: subscription.lead.id,
				inactive: subscription.inactive,
			};
            const i = marketReportSubscriptions.findIndex((value) => value.id === resource.id);
            marketReportSubscriptions[i] = resource;
        } else {
			const resource: MarketReportSubscriptionResource = {
				id: generateId(),
				marketReportId: subscription.report.id,
				leadId: subscription.lead.id,
				inactive: subscription.inactive,
			}
            marketReportSubscriptions.push(resource);
        }
    });
    return resolve<MarketReportSubscriptionResource[]>(marketReportSubscriptions);
}

export const getTasks = () => {
    return resolve(tasks);
}
export const createTask = (task: NewTask) => {
	const resource = {
		id: generateId(),
		leadId: task.leadId,
		agentId: task.agentId,
		creatorId: task.creatorId,
		title: task.title,
		description: task.description,
		taskTypeId: task.type && task.type.id,
		taskStatusTypeId: task.status && task.status.id,
		priority: task.priority,
		startOn: task.startOn && task.startOn.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		endOn: task.endOn && task.endOn.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		createdOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	tasks.push(resource);
	return resolve<TaskResource>(resource);
};

export const updateTask = (task: Task) => {
	const resource: TaskResource = {
		id: task.id,
		leadId: task.leadId,
		agentId: task.agentId,
		creatorId: task.creatorId,
		title: task.title,
		description: task.description,
		taskTypeId: task.type && task.type.id,
		taskStatusTypeId: task.status && task.status.id,
		priority: task.priority,
		startOn: task.startOn && task.startOn.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		endOn: task.endOn && task.endOn.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		updatedOn: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
		createdOn: task.createdOn.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
	};
	const i = tasks.findIndex((value) => value.id === task.id);
	tasks[i] = resource;
	return resolve<TaskResource>(resource);
};

export const getAgents = () => {
    return resolve(agents);
}

export const createAgent = (agent: NewAgent) => {
	const resource: AgentResource = {
		id: generateId(),
		firstName: agent.firstName,
		lastName: agent.lastName,
		email: agent.email,
		officeId: agent.office && agent.office.id,
		agentPageUrl: agent.agentPageUrl,
		lastLoginDate: generateTimestamp(),
		designation: agent.designation,
		username: agent.username,
		password: agent.password,
		homePhone: agent.homePhone,
		officePhone: agent.officePhone,
		homeFax: agent.homeFax,
		officeFax: agent.officeFax,
		cellPhone: agent.cellPhone,
		staffTypeId: agent.staffType && agent.staffType.id,
		code: agent.code,
		officeAddress: agent.officeAddress,
		officeCity: agent.officeCity,
		officeState: agent.officeState,
		officeZip: agent.officeZip,
		photoUrl: agent.photoUrl,
		head: agent.head,
		body: agent.body,
		allowModifyBio: agent.allowModifyBio,
		hasOwnSite: agent.hasOwnSite,
		redirectUrl: agent.redirectUrl,
		enableAgentLink: agent.enableAgentLink,
		showOnSignupDropDown: agent.showOnSignupDropDown,
		emailHeader: agent.emailHeader,
		sendEmailUpdatesToAgent: agent.sendEmailUpdatesToAgent,
		allowModifyListings: agent.allowModifyListings,
		allowModifySubscribers: agent.allowModifySubscribers,
		languageIds: agent.languageIds,
		admin: agent.admin,
		ownsLeads: agent.ownsLeads,
	};
	agents.push(resource);
	return resolve<AgentResource>(resource);
};

export const updateAgent = (agent: Agent) => {
	const i = agents.findIndex((value) => value.id === agent.id);
        const resource = {
            ...agents[i],
            firstName: agent.firstName,
            lastName: agent.lastName,
            email: agent.email,
            officeId: agent.office && agent.office.id,
            agentPageUrl: agent.agentPageUrl,
            lastLoginDate: agent.lastLoginDate?.toString(),
            designation: agent.designation,
            username: agent.username,
            password: agent.password,
            homePhone: agent.homePhone,
            officePhone: agent.officePhone,
            homeFax: agent.homeFax,
            officeFax: agent.officeFax,
            cellPhone: agent.cellPhone,
            staffTypeId: agent.staffType && agent.staffType.id,
            code: agent.code,
            officeAddress: agent.officeAddress,
            officeCity: agent.officeCity,
            officeState: agent.officeState,
            officeZip: agent.officeZip,
            photoUrl: agent.photoUrl,
            head: agent.head,
            body: agent.body,
            allowModifyBio: agent.allowModifyBio,
            hasOwnSite: agent.hasOwnSite,
            redirectUrl: agent.redirectUrl,
            enableAgentLink: agent.enableAgentLink,
            showOnSignupDropDown: agent.showOnSignupDropDown,
            emailHeader: agent.emailHeader,
            sendEmailUpdatesToAgent: agent.sendEmailUpdatesToAgent,
            allowModifyListings: agent.allowModifyListings,
            allowModifySubscribers: agent.allowModifySubscribers,
			admin: agent.admin
        };
        agents[i] = resource;
		return resolve<AgentResource>(resource);
};

export const updateSplashScreenSettings = ({ id, splashScreenSkipDate }: { id: number; splashScreenSkipDate: string }) => {
	const i = agents.findIndex((value) => value.id === id);
	const resource: AgentResource = {
		...agents[i],
		id,
		splashScreenSkipDate,
	};

	agents[i] = resource;
	return resolve<AgentResource>(resource);
}

export const getAgentTestimonials = (agentId: number) => {
	return resolve<AgentPublicBioTestimonialResource[]>([]);
};

export const createAgentTestimonial = (agentId: number, testimonial: { quote: string; author: string }) => {
	const resource: AgentPublicBioTestimonialResource = { id: Date.now(), ...testimonial };
	return resolve<AgentPublicBioTestimonialResource>(resource);
};

export const updateAgentTestimonial = (agentId: number, testimonialId: number, testimonial: { quote: string; author: string }) => {
	const resource: AgentPublicBioTestimonialResource = { id: testimonialId, ...testimonial };
	return resolve<AgentPublicBioTestimonialResource>(resource);
};

export const deleteAgentTestimonial = (agentId: number, testimonialId: number) => {
	return resolve<void>(undefined);
};

export const updateAgents = (agentList: Agent[]) => {
	let resources: AgentResource[] = [];
	agentList.forEach((agent) => {
		const i = agents.findIndex((value) => value.id === agent.id);
			const resource = {
				...agents[i],
				firstName: agent.firstName,
				lastName: agent.lastName,
				email: agent.email,
				officeId: agent.office && agent.office.id,
				agentPageUrl: agent.agentPageUrl,
				lastLoginDate: agent.lastLoginDate?.toString(),
				designation: agent.designation,
				username: agent.username,
				password: agent.password,
				homePhone: agent.homePhone,
				officePhone: agent.officePhone,
				homeFax: agent.homeFax,
				officeFax: agent.officeFax,
				cellPhone: agent.cellPhone,
				staffTypeId: agent.staffType && agent.staffType.id,
				code: agent.code,
				officeAddress: agent.officeAddress,
				officeCity: agent.officeCity,
				officeState: agent.officeState,
				officeZip: agent.officeZip,
				photoUrl: agent.photoUrl,
				head: agent.head,
				body: agent.body,
				allowModifyBio: agent.allowModifyBio,
				hasOwnSite: agent.hasOwnSite,
				redirectUrl: agent.redirectUrl,
				enableAgentLink: agent.enableAgentLink,
				showOnSignupDropDown: agent.showOnSignupDropDown,
				emailHeader: agent.emailHeader,
				sendEmailUpdatesToAgent: agent.sendEmailUpdatesToAgent,
				allowModifyListings: agent.allowModifyListings,
				allowModifySubscribers: agent.allowModifySubscribers,
				admin: agent.admin,
				showImageOnPage: agent.showImageOnPage,
			};
			agents[i] = resource;
			resources.push(resource)
	})
	return resolve<AgentResource[]>(resources);
};

export const deleteAgent = (agent: Agent) => {
    const i = agents.findIndex(value => value.id === agent.id);
    const resource = agents[i];
    agents.splice(i, 1);
    return resolve(resource);
}

export const getBoards = () => {
    return resolve(boards);
};

export const getAgentBoards = () => {
    return resolve(agentBoards);
}

export const createAgentBoard = (agentBoard: NewAgentBoard) => {
    const resource: AgentBoardResource = {
        id: generateId(),
        agentId: agentBoard.agentId,
        agentCode: agentBoard.agentCode,
        boardId: agentBoard.boardId,
    };
    agentBoards.push(resource);
    return resolve<AgentBoardResource>(resource);
};

export const updateAgentBoard = (agentBoard: AgentBoard) => {
    const i = agentBoards.findIndex((value) => value.id === agentBoard.id);
    const resource: AgentBoardResource = {
        ...agentBoards[i],
        agentId: agentBoard.agentId,
        agentCode: agentBoard.agentCode,
        boardId: agentBoard.boardId,
    };
    agentBoards[i] = resource;
    return resolve<AgentBoardResource>(resource);
};

export const deleteAgentBoard = (agentBoard: AgentBoard) => {
    const i = agentBoards.findIndex(value => value.id === agentBoard.id);
    const resource = agentBoards[i];
    agentBoards.splice(i, 1);
    return resolve(resource);
}

const clientBoards: ClientBoardResource[] = [
    {
        id: 1,
        boardId: 1,
        boardName: "San Diego MLS",
        agentId: "AG-100",
        officeId: "OFF-100",
        status: "APPROVED",
    },
    {
        id: 2,
        boardId: 2,
        boardName: "Los Angeles MLS",
        agentId: "",
        officeId: "",
        status: "APPROVED",
    },
    {
        id: 3,
        boardId: 3,
        boardName: "Austin Board of Realtors",
        agentId: "",
        officeId: "",
        status: "PENDING",
    },
];

// Provisioned-only picker options (D14): each maps to an existing ClientBoard row.
const clientBoardOptions: BoardOption[] = [
    { boardId: 1, clientBoardId: 1, state: "CA", shortName: "San Diego MLS", region: "San Diego", label: "CA: San Diego MLS - San Diego (1)" },
    { boardId: 2, clientBoardId: 2, state: "CA", shortName: "Los Angeles MLS", region: "Los Angeles", label: "CA: Los Angeles MLS - Los Angeles (2)" },
    { boardId: 3, clientBoardId: 3, state: "TX", shortName: "Austin Board of Realtors", region: "Austin", label: "TX: Austin Board of Realtors - Austin (3)" },
];

// Worked out from the mock's own agents, agent boards and client boards, so it agrees with them.
export const getAgentMlsIds = () => {
    const mlsIdAgents = agents.map((agent) => ({ id: agent.id, name: [agent.firstName, agent.lastName].filter(Boolean).join(" "), billable: agent.ownsLeads }));
    return resolve(mlsIdReads({ officeAccount: false, agents: mlsIdAgents, clientBoards, agentBoards }).agentMlsIds);
}

// The mock doesn't run the MLS ID rules, so it has no agent MLS ID writes.
const mlsIdWritesOffline = () => Promise.reject(new Error("MLS ID writes need the live API."));

export const createAgentMlsId = (agentMlsId: NewAgentMlsIdResource) => mlsIdWritesOffline() as Promise<AgentMlsIdResource>;

export const updateAgentMlsId = (id: number, agentMlsId: NewAgentMlsIdResource) => mlsIdWritesOffline() as Promise<AgentMlsIdResource>;

export const deleteAgentMlsId = (id: number) => mlsIdWritesOffline() as Promise<void>;

export const getClientBoards = () => {
    return resolve<ClientBoardListResource>({ officeAccount: false, clientBoards });
}

// The mock doesn't run the MLS ID rules, so strict is ignored.
export const updateClientBoard = (id: number, clientBoard: ClientBoardResource, strict = false) => {
    const i = clientBoards.findIndex((value) => value.id === id);
    const resource: ClientBoardResource = {
        ...clientBoards[i],
        agentId: clientBoard.agentId,
        officeId: clientBoard.officeId,
    };
    clientBoards[i] = resource;
    return resolve<ClientBoardResource>(resource);
}

export const addClientBoard = (clientBoard: ClientBoardResource, strict = false) => {
    // CF "Add Profile": always insert a NEW row, never overwrite an existing one.
    const id = clientBoards.reduce((max, cb) => Math.max(max, cb.id), 0) + 1;
    const resource: ClientBoardResource = {
        ...clientBoard,
        id,
        status: "APPROVED",
    };
    clientBoards.push(resource);
    return resolve<ClientBoardResource>(resource);
}

export const getClientBoardOptions = () => {
    return resolve(clientBoardOptions);
}

export const getOffices = () => {
    return resolve(offices);
}

export const createOffice = (office: NewOffice) => {
	const resource: OfficeResource = {
		id: generateId(),
		name: office.name,
		code: office.code,
		priority: office.priority,
		address: office.address,
		city: office.city,
		state: office.state,
		zip: office.zip,
		phone: office.phone,
		fax: office.fax,
		email: office.email,
		photoUrl: office.photoUrl,
		header: office.header,
		description: office.description,
	};
	offices.push(resource);
	return resolve<OfficeResource>(resource);
};

export const updateOffices = (officeList: Office[]) => {
	// Mirrors the server: renumber priority densely from the given order.
	officeList.forEach((office, index) => {
		const i = offices.findIndex((value) => value.id === office.id);
		if (i >= 0) {
			offices[i] = { ...offices[i], priority: index };
		}
	});
	const resources = officeList
		.map((office) => offices.find((value) => value.id === office.id))
		.filter(Boolean) as OfficeResource[];
	return resolve<OfficeResource[]>(resources);
};

export const updateOffice = (office: Office) => {
	const i = offices.findIndex((value) => value.id === office.id);
		const resource = {
			...offices[i],
			name: office.name,
			code: office.code,
			priority: office.priority,
			address: office.address,
			city: office.city,
			state: office.state,
			zip: office.zip,
			phone: office.phone,
			fax: office.fax,
			email: office.email,
			photoUrl: office.photoUrl,
			header: office.header,
			description: office.description,
		};
		offices[i] = resource;
		return resolve<OfficeResource>(resource);
};

export const deleteOffice = (office: Office) => {
    const i = offices.findIndex(value => value.id === office.id);
    const resource = offices[i];
    offices.splice(i,1);
    return resolve(resource);
}

export const getOfficeBoards = () => {
    return resolve(officeBoards);
}

export const createOfficeBoard = (officeBoard: NewOfficeBoard) => {
	const resource: OfficeBoardResource = {
		id: generateId(),
		officeId: officeBoard.officeId,
		officeCode: officeBoard.officeCode,
		boardId: officeBoard.boardId,
	};
	officeBoards.push(resource);
	return resolve<OfficeBoardResource>(resource);
};

export const updateOfficeBoard = (officeBoard: OfficeBoard) => {
	const i = officeBoards.findIndex((value) => value.id === officeBoard.id);
	const resource: OfficeBoardResource = {
		...officeBoards[i],
		officeId: officeBoard.officeId,
		officeCode: officeBoard.officeCode,
		boardId: officeBoard.boardId,
	};
	officeBoards[i] = resource;
	return resolve<OfficeBoardResource>(resource);
};

export const deleteOfficeBoard = (officeBoard: OfficeBoard) => {
    const i = officeBoards.findIndex(value => value.id === officeBoard.id);
    const resource = officeBoards[i];
    officeBoards.splice(i, 1);
    return resolve(resource);
}

export const getCities = () => {
    return resolve(cities);
}

export const getNeighborhoods = () => {
    return resolve(neighborhoods);
}

export const getAggregateStats = () => {
    return resolve(aggregateStats);
}

export const getIntegrations = () => {
    // Mock returns all integrations (both account and agent-level)
    // In real API, this would be filtered by ownerTypeId
    return resolve(integrations);
}

export const saveIntegration = (integration: IntegrationPartial) => {
    let resource: IntegrationResource;
    if (integration.id) {
        const index = integrations.findIndex((value) => value.id === integration.id);
        resource = {
            ...integrations[index],
            integrationTypeId: integration.integrationType.id,
            name: integration.name,
            data: integration.data,
        }
        integrations[index] = resource;
    } else {
        resource = {
            id: generateId(),
            integrationTypeId: integration.integrationType.id,
            name: integration.name,
            data: integration.data,
            createdOn: generateTimestamp(),
        }
        integrations.push(resource)
    }
    return resolve<IntegrationResource>(resource);
}

export const testIntegration = (integration: IntegrationPartial) => {
    return resolve(undefined)
}

export const getIntegrationCalendars = (integrationId: number) => {
    return resolve(integrationCalendars.filter((integrationCalendar) => integrationCalendar.integrationId === integrationId));
}

export const getFacebookPages = () => {
    return resolve({
        pages: [
            {
                id: "123456789",
                name: "My Test Facebook Page",
                accessToken: "mock_token",
                category: "Real Estate"
            }
        ]
    });
}

export const deleteIntegration = (integration: IntegrationPartial) => {
    const index = integrations.findIndex((value) => value.id === integration.id);
    const resource = integrations[index];
    if (index !== -1) {
        integrations.splice(index, 1);
    }
    return resolve<IntegrationResource>(resource);
}

export const getSiteLinks = () => {
    return resolve(siteLinks);
}

export const connectFollowUpBoss = (integrationId: number, apiKey: string) => {
    const index = integrations.findIndex((i) => i.id === integrationId);
    if (index !== -1) {
        integrations[index] = { ...integrations[index], data: { ...integrations[index].data, externalKey: apiKey } };
    }
    return resolve({ message: undefined as string | undefined });
};

export const disconnectFollowUpBoss = (integrationId: number) => {
    const index = integrations.findIndex((i) => i.id === integrationId);
    if (index !== -1) {
        const { externalKey: _removed, ...rest } = integrations[index].data as any || {};
        integrations[index] = { ...integrations[index], data: rest };
    }
    return resolve({ message: undefined as string | undefined });
};

export const getFollowUpBossStatus = (integrationId: number) => {
    const integration = integrations.find((i) => i.id === integrationId);
    const connected = !!(integration?.data as any)?.externalKey;
    if (!connected) {
        return resolve({
            connected: false,
            webhooksActive: 0,
            webhooksMissing: 0,
            webhookLastHealthCheckDate: null as number | null,
            agentsMatched: null as number | null,
            ihfAgentsNotInFub: null as number | null,
            fubUsersNotInIhf: null as number | null,
            backfillStatus: null as "not_started" | "running" | "complete" | "failed" | null,
            apiKeyValid: null as boolean | null,
            lastWebhookProcessed: null as number | null,
            lastSyncDate: null as number | null,
            errorCount24h: 0,
            backfillLeadsStatus: null as string | null,
            backfillEventsStatus: null as string | null,
            leadsMatched: null as number | null,
            leadsUnmatched: null as number | null,
        });
    }
    return resolve({
        connected: true,
        webhooksActive: 2,
        webhooksMissing: 0,
        webhookLastHealthCheckDate: Date.now() - 300000 as number | null,
        agentsMatched: 3 as number | null,
        ihfAgentsNotInFub: 1 as number | null,
        fubUsersNotInIhf: 0 as number | null,
        backfillStatus: "complete" as "not_started" | "running" | "complete" | "failed" | null,
        apiKeyValid: true as boolean | null,
        lastWebhookProcessed: Date.now() - 600000 as number | null,
        lastSyncDate: Date.now() - 600000 as number | null,
        errorCount24h: 0,
        backfillLeadsStatus: null as string | null,
        backfillEventsStatus: null as string | null,
        leadsMatched: 148 as number | null,
        leadsUnmatched: 0 as number | null,
    });
};

export const startFollowUpBossBackfill = (_integrationId: number) => {
    return resolve({});
};

// MAX-4236: in-memory agent selection per integration. Three eligible FUB users and three
// lead-owning agents, with the mock user carrying agentSeatCap 2 so the counter is exercised.
// MAX-4579: a saved selection is locked; a second PUT is refused the way the server's 409 is.
const mockAgentSelections: Record<number, FollowUpBossAgentSelection> = {};

const defaultMockAgentSelection = (): FollowUpBossAgentSelection => ({
    selectionMode: true,
    seatCap: 2,
    confirmed: false,
    fubUsers: [
        { id: 1, name: "Jane Broker", email: "jane@example.com", role: "Broker", status: "Active", isOwner: true },
        { id: 2, name: "Sam Agent", email: "sam@example.com", role: "Agent", status: "Invited", isOwner: false },
        { id: 3, name: "Taylor Agent", email: "taylor@example.com", role: "Agent", status: "Active", isOwner: false },
    ],
    ihfAgents: [
        { id: 101, name: "Jane Broker", email: "jane@example.com" },
        { id: 102, name: "Sam Agent", email: "sam@example.com" },
        { id: 103, name: "Pat Agent", email: "pat@example.com" },
    ],
    pairs: [{ fubUserId: 1, agentId: 101 }, { fubUserId: 2, agentId: 102 }],
});

export const getFollowUpBossAgentSelection = (integrationId: number) => {
    if (!mockAgentSelections[integrationId]) {
        mockAgentSelections[integrationId] = defaultMockAgentSelection();
    }
    return resolve(mockAgentSelections[integrationId]);
};

export const saveFollowUpBossAgentSelection = (integrationId: number, body: FollowUpBossAgentSelectionRequest) => {
    const current = mockAgentSelections[integrationId] ?? defaultMockAgentSelection();
    if (current.confirmed) {
        return Promise.reject(new Error("Your Follow Up Boss agent selection is locked. Contact support to change it."));
    }
    if (current.seatCap !== null && body.pairs.length > current.seatCap) {
        return Promise.reject(new Error(`You can select up to ${current.seatCap} agents on your plan.`));
    }
    const order = new Map(current.fubUsers.map((u, i) => [u.id, i] as [number, number]));
    const pairs = [...body.pairs].sort((a, b) => (order.get(a.fubUserId) ?? 0) - (order.get(b.fubUserId) ?? 0));
    mockAgentSelections[integrationId] = {
        ...current,
        confirmed: true,
        pairs,
    };
    return resolve(mockAgentSelections[integrationId]);
};


// Mock doesnt require a signature; return an empty object
export const getUploadSignature = (uploadPreset: string) => {
    return resolve({});
}

export const getGeocode = (address?: string) => {
    // 2560 Ninth St, Berkeley, CA 94710
    return resolve<[ number, number ]>([ -122.291451, 37.859249 ]);
}

export const getPages = () => {
    return resolve(pages);
}

export const savePage = (page: PagePartial) => {
    const resource: PageResource = {
        id: page.id,
        typeId: page.type.id,
        path: page.path,
        title: page.title,
        head: page.head,
        enabled: page.enabled,
    };
    const i = pages.findIndex((value) => value.id === page.id);
    pages[i] = resource;
    return resolve<PageResource>(resource);
}

export const getLanguages = () => {
    return resolve(languages);
}

export const getNaturalLanguageSearchSuggestions = () => {
	return resolve(naturalLanguageSearchSuggestions);
}

export const createNaturalLanguageSearchSuggestion = (suggestion: NewNaturalLanguageSearchSuggestion) => {
	const resource: NaturalLanguageSearchSuggestionResource = {
		id: generateId(),
		nls: suggestion.nls,
		promoted: suggestion.promoted,
	};
	naturalLanguageSearchSuggestions.push(resource);
	return resolve<NaturalLanguageSearchSuggestionResource>(resource);
}

export const updateNaturalLanguageSearchSuggestion = (suggestion: NaturalLanguageSearchSuggestion) => {
	const index = naturalLanguageSearchSuggestions.findIndex((value) => value.id === suggestion.id);
	const resource: NaturalLanguageSearchSuggestionResource = {
		id: suggestion.id,
		nls: suggestion.nls,
		promoted: suggestion.promoted,
	};
	naturalLanguageSearchSuggestions[index] = resource;
	return resolve<NaturalLanguageSearchSuggestionResource>(resource);
}

export const deleteNaturalLanguageSearchSuggestion = (id: number) => {
	const index = naturalLanguageSearchSuggestions.findIndex((value) => value.id === id);
	const resource = naturalLanguageSearchSuggestions[index];
	naturalLanguageSearchSuggestions.splice(index, 1);
	return resolve(resource);
}

export const getAreaSelectorPlaceholders = () => {
	return resolve(areaSelectorPlaceholders);
}

export const createAreaSelectorPlaceholder = (placeholder: NewAreaSelectorPlaceholder) => {
	const resource: AreaSelectorPlaceholderResource = {
		id: generateId(),
		text: placeholder.text,
	};
	areaSelectorPlaceholders.push(resource);
	return resolve<AreaSelectorPlaceholderResource>(resource);
}

export const updateAreaSelectorPlaceholder = (placeholder: AreaSelectorPlaceholder) => {
	const index = areaSelectorPlaceholders.findIndex((value) => value.id === placeholder.id);
	const resource: AreaSelectorPlaceholderResource = {
		id: placeholder.id,
		text: placeholder.text,
	};
	areaSelectorPlaceholders[index] = resource;
	return resolve<AreaSelectorPlaceholderResource>(resource);
}

export const deleteAreaSelectorPlaceholder = (id: number) => {
	const index = areaSelectorPlaceholders.findIndex((value) => value.id === id);
	const resource = areaSelectorPlaceholders[index];
	areaSelectorPlaceholders.splice(index, 1);
	return resolve(resource);
}

export const getEmailRoutingRules = () => {
	return resolve([]);
}

export const bulkUpsertEmailRoutingRules = (body: any[]) => {
	return resolve(body);
}

export const getEmailRecipients = () => {
	return resolve([]);
}

export const addEmailRecipients = (body: any[]) => {
	return resolve(body);
}

export const deleteEmailRecipient = (clientEmailRecipientId: number) => {
	return resolve(undefined);
}

// MAX-4194: annotated with the resource type so a future field omission fails here rather than
// silently in the slice.
export const getOffMarketListings = () => {
	return resolve<OffMarketListingListResource>({
		agentControl: "none",
		automatedFeaturedSolds: false,
		featureAgentOffice: false,
		officeAccount: false,
		soldsOnFeaturedYn: false,
		listings: [],
	});
}

export const createOffMarketListing = (body: any) => {
	return resolve({ ...body, id: 1, clientPropertyId: 1 });
}

export const updateOffMarketListing = (id: number, body: any) => {
	return resolve({ ...body, id, clientPropertyId: id });
}

export const deleteOffMarketListing = (id: number) => {
	return resolve(undefined);
}

// MAX-4194: annotated with the resource type so a future field omission fails here rather than
// silently in the slice.
export const getClientProperties = () => {
	return resolve<ClientPropertyListResource>({
		agentControl: "none",
		showAgentPageColumn: false,
		officeAccount: false,
		supplementalOnFeaturedYn: false,
		items: [],
	});
}

export const getClientProperty = (id: number) => {
	// MAX-4194: `agentId` is what makes the seeding path reachable under mocks. The seed fires
	// only when the row has an agent id and no typed name, so with no `agentId` here that branch
	// — the one with no automated coverage, since RTL is unavailable repo-wide — could never be
	// exercised locally. `agentName: ""` is included to match the shape the server actually
	// returns (getAgentName() returns "", never null), not because the baseline needs it: the
	// initialiser is `property?.agentName || agentNameSeed || ""`, so undefined and "" behave
	// identically. The cast defeats type checking either way.
	return resolve({ id, boardId: 0, listingNumber: String(id), status: "Active", propertyType: "SFR", agentName: "", agentId: 7 } as any as ClientPropertyResource);
}

export const createClientProperty = (body: any) => {
	return resolve({ ...body, id: 1 });
}

export const updateClientProperty = (id: number, body: any) => {
	return resolve({ ...body, id });
}

export const deleteClientProperty = (id: number) => {
	return resolve(undefined);
}

const EMPTY_PHOTO_MANAGER: PhotoManagerResource = {
	mainPhotoUrl: null,
	photoYn: false,
	canRevertToMls: false,
	photos: [],
};

export const getListingPhotos = (key: ListingPhotoKey) => {
	return resolve(EMPTY_PHOTO_MANAGER);
}

export const addListingPhoto = (key: ListingPhotoKey, body: AddListingPhotoResource) => {
	return resolve({
		mainPhotoUrl: body.mainPhoto ? body.photoUrl : null,
		photoYn: !!body.mainPhoto,
		canRevertToMls: false,
		photos: [{ propertyPhotoId: 1, photoUrl: body.photoUrl, caption: body.caption || null, priority: 1 }],
	} as PhotoManagerResource);
}

export const reorderListingPhotos = (key: ListingPhotoKey, body: ReorderListingPhotosResource) => {
	return resolve(EMPTY_PHOTO_MANAGER);
}

export const deleteListingPhoto = (propertyPhotoId: number, key: ListingPhotoKey) => {
	return resolve(undefined);
}

export const makeMainListingPhoto = (key: ListingPhotoKey, body: MakeMainListingPhotoResource) => {
	return resolve(EMPTY_PHOTO_MANAGER);
}

export const revertListingPhotosToMls = (key: ListingPhotoKey) => {
	return resolve({ ...EMPTY_PHOTO_MANAGER, canRevertToMls: true });
}

export const getLeadContactReport = (params: any) => {
	return resolve({ activities: [], totalCount: 0 } as LeadContactReportResource);
}

export const getContactEventTypes = () => {
	return resolve([] as ContactEventTypeResource[]);
}

export const getSavedSearchActivity = (params: any) => {
	return resolve({ rows: [], totalCount: 0 } as SavedSearchActivityReportResource);
}

export const getSavedListingsReport = (startDate?: string, endDate?: string) => {
	return resolve([] as SavedListingReportResource[]);
}

export const getMobileActivity = (params: any) => {
	return resolve({ total: 0, rows: [] } as MobileActivityReportResponse);
}

export const exportLeads = async (orderBy: string, includeDisabled: boolean, includeDeleted: boolean) => {
	return;
}

export const exportAgents = async () => {
	saveBlob(new Blob(["\"AgentId\",\"FirstName\",\"LastName\"\r\n\"1\",\"Mock\",\"Agent\"\r\n"], { type: "text/csv" }), "AgentStats.csv");
}

export const getActiveListings = (params: any) => {
	return resolve([] as ActiveListingResource[]);
}

export const getActiveListingModify = (params: { listingNumber: string; boardId: number }) => {
	// Empty-overrides case: the MLS REMARKS come through as defaultDescription while every override
	// field is blank, exercising the "Default MLS Description" hint path.
	return resolve({
		listingNumber: params.listingNumber,
		boardId: params.boardId,
		defaultDescription: "Charming 3-bedroom home with an updated kitchen and a large fenced yard.",
		propDescription: null,
		tourYn: false,
		tourUrl: null,
		tourLink: null,
		openYn: false,
		openDateText: null,
		openDate: null,
		openTime: null,
		openAgent: null,
		openHomeDirections: null,
		openHomeRemarks: null,
		mapYn: true,
		extraLinkYn: false,
		extraLinkUrl: null,
		extraLinkText: null,
	} as ActiveListingModifyResource);
}

export const updateActiveListingModify = (
	params: { listingNumber: string; boardId: number },
	body: UpdateActiveListingModifyResource
) => {
	return resolve({
		listingNumber: params.listingNumber,
		boardId: params.boardId,
		defaultDescription: "Charming 3-bedroom home with an updated kitchen and a large fenced yard.",
		...body,
	} as ActiveListingModifyResource);
}

export const getEmailBranding = () => {
	return resolve({
		type: "basic",
		photoUrl: "",
		logoUrl: "",
		name: "",
		company: "",
		phone: "",
		addressLine1: "",
		addressLine2: "",
		customHeaderHtml: "",
		customFooterHtml: "",
		emailBrandingEnabled: true,
	} as EmailBrandingResource);
}

export const updateEmailBranding = (body: EmailBrandingResource) => {
	return resolve(body);
}

export const previewEmailBranding = async (body: EmailBrandingResource) => {
	return "<html><body>Preview</body></html>";
}

// A page can pick a scenario with localStorage["mockBillingScenario"] (e.g. "recurlyDown"), which is how
// the e2e tests reach states the default account never shows.
const billingScenario = (): BillingResource => {
	const name = window.localStorage.getItem("mockBillingScenario") as keyof typeof billingScenarios | null;
	return (name && billingScenarios[name]) || billing;
};

let billingMock: BillingResource = billingScenario();

export const getBilling = () => {
	return resolve<BillingResource>(billingMock);
}

export const updateBillingCard = (token: string) => {
	if (token === DECLINED_CARD_TOKEN) {
		return new Promise<BillingCardResource>((_, reject) => {
			setTimeout(() => reject(Object.assign(new Error("Card declined"), { status: 422, code: "DECLINED" })), 500);
		});
	}
	const card: BillingCardResource = {
		...(billingMock.card ?? { paymentType: "card" }),
		paymentType: "card",
		cardType: "Visa",
		lastFour: "1111",
	};
	billingMock = { ...billingMock, card };
	return resolve<BillingCardResource>(card);
}

export const getBillingInvoices = () => {
	return resolve<BillingInvoiceResource[]>(billingInvoices);
}

export const downloadBillingInvoice = async (displayNumber: string) => {
	return;
}

export const exchangeNylasToken = async (obj: NylasTokenRequest): Promise<NylasTokenResponse> => {
	try {
		const body: NylasTokenRequest = {
			grant_type: 'authorization_code',
			code_verifier: 'nylas',
			...obj,
		}
		const request = await fetch('https://api.us.nylas.com/v3/connect/token', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body),
		});
		if (!request.ok) {
			const errorData = await request.json();
			throw new Error(errorData.error_description || 'Failed to exchange token');
		}
		const data = await request.json();
		return data as NylasTokenResponse;
	} catch(error) {
		if (error instanceof Error) {
			throw new Error(`Failed to exchange Nylas token: ${error.message}`);
		}
		throw new Error('An unexpected error occurred while exchanging Nylas token');
	}
}
